import { useState } from 'react';
import { querySetParkerToNeutral } from '../Queries/Parker';

const errorMessage = 'Failed to set parker to neutral'

export function useSetParkerToNeutral(parkerId) {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const setParkerToNeutral = async () => {
        if(!parkerId) return;

        try {
            setIsLoading(true);

            const res = await querySetParkerToNeutral({ parkerId });

            if(!res.data?.setParkerToNeutral) {
                return setError(errorMessage);
            }

            return setError(null);
        } catch {
            return setError(errorMessage);
        } finally {
            return setIsLoading(false);
        }
    }

    return {
        inProgress: isLoading,
        setInProgress: setIsLoading,
        errorMessage: error,
        setParkerToNeutral
    }
}